import React from "react";

import "./styles.scss";
import { EditorMenuBar } from "@/shared/forms/satos-editor/EditorMenuBar";
import { TipTapExtensions } from "@/shared/forms/satos-editor/TiptapExtensions";
import { FormHelperText, Typography } from "@mui/material";
import { EditorProvider } from "@tiptap/react";
import { useField, useFormikContext } from "formik";

type SATOSEditorProps = {
	id: string;
	name: string;
	label: string;
	disabled?: boolean;
	imageUploadDisabled?: boolean | undefined;
	style?: React.CSSProperties;
	["aria-required"]?: boolean | string;
	["aria-describedby"]?: string;
};

const SATOSEditorField = ({
	id,
	name,
	label,
	disabled,
	imageUploadDisabled,
	style,
	"aria-required": ariaRequired,
	"aria-describedby": ariaDescribedby,
}: SATOSEditorProps) => {
	const [field, meta, helpers] = useField(name);
	const { setFieldTouched } = useFormikContext();

	const showError = meta.touched && !!meta.error;

	return (
		<div className="input-container" style={{ marginBottom: "1rem" }}>
			<Typography
				component="label"
				htmlFor={id}
				variant="body2"
				sx={{
					color: "text.secondary",
					mb: 0.5,
					display: "block",
					cursor: "pointer",
				}}
			>
				{label}
			</Typography>
			<EditorProvider
				extensions={TipTapExtensions}
				content={field.value}
				slotBefore={
					<EditorMenuBar imageUploadDisabled={Boolean(imageUploadDisabled)} />
				}
				editable={!disabled}
				onUpdate={({ editor }) => {
					const html = editor.getHTML();
					helpers.setValue(html);
				}}
				onBlur={() => {
					setFieldTouched(name, true);
				}}
				editorProps={{
					attributes: {
						id,
						style: {
							minHeight: "300px",
							overflow: "auto",
							resize: "vertical",
							...style,
						},
						"aria-required": ariaRequired,
						"aria-describedby": ariaDescribedby,
					} as any,
				}}
			/>
			{showError && (
				<FormHelperText error id={`${id}-error-text`}>
					{meta.error}
				</FormHelperText>
			)}
		</div>
	);
};

export default SATOSEditorField;
